import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models/column';

@Pipe({ name: 'distinct' })
export class DistinctPipe implements PipeTransform {
    transform(value: Array<any>, col: Column): Array<any> {
        return [...Array.from(new Set(value.map(item => item[col.colName.toString()])))];
    }
    transformArr(value: Array<any>): Array<any> {
        return [...Array.from(new Set(value))];
    }
}
